import React from 'react';

const MinhembioIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="41"
    viewBox="0 0 36 41"
  >
    <g fill="none">
      <path d="M0.8 20.6L3.3 20.4 3.3 29.1 1.3 28.4 0.8 20.6ZM1.4 13.1L12.5 0.7 34.4 8.9 25.4 10.1 25.2 5.9 13.4 11.6 1.4 13.1ZM1.6 25.1C1.6 25.8 1.8 26.1 2.3 26.1 2.7 26.1 2.9 25.8 2.9 25.1 2.9 24.5 2.7 24.2 2.3 24.2 1.8 24.2 1.6 24.5 1.6 25.1ZM1.6 22.9C1.6 23.6 1.8 23.9 2.3 23.9 2.7 23.9 2.9 23.6 2.9 22.9 2.9 22.3 2.7 22 2.3 22 1.8 22 1.6 22.3 1.6 22.9ZM4.9 16.6L24.6 7.2 23.9 36.3 5.5 29.7 4.9 16.6ZM8.4 33.1L17.8 35.3 17.4 40.6 8.7 36.9 8.4 33.1ZM27.7 17.3L35.4 16.6 34.5 40.6 28.9 38.7 27.7 17.3ZM29.9 29.3L29.9 29.4C29.9 30.1 30.1 30.8 30.4 31.3 30.8 31.8 31.2 32.1 31.7 32.1 32.2 32.1 32.6 31.8 32.9 31.3 33.3 30.8 33.5 30.1 33.4 29.4 33.5 28.6 33.3 27.9 32.9 27.4 32.6 26.9 32.2 26.6 31.7 26.7 31.2 26.6 30.8 26.9 30.4 27.4 30.1 27.9 29.9 28.6 29.9 29.3ZM29.9 23.1L29.9 23.1C29.9 23.9 30.1 24.6 30.4 25.1 30.8 25.6 31.2 25.9 31.7 25.9 32.1 25.9 32.6 25.6 32.9 25.1 33.3 24.6 33.4 23.9 33.4 23.1 33.4 22.4 33.3 21.8 32.9 21.2 32.6 20.7 32.1 20.4 31.7 20.4 31.2 20.4 30.8 20.7 30.4 21.2 30.1 21.8 29.9 22.4 29.9 23.1Z" />
    </g>
  </svg>
);

export default MinhembioIcon;
